import { FieldPath, FieldValues } from "react-hook-form";

import SinglePickerFormField from "src/components/Pickers/SinglePickerFormField.tsx";
import { PickerFormFieldPropsType } from "src/components/Pickers/typings.ts";
import { CaseType } from "src/graphql/anti-fraud/__generated__/graphql.ts";
import { useGetCaseTypesSchemasQuery } from "src/graphql/anti-fraud/queries/caseTypes/CaseTypesSchemasQuery.ts";
import { useT } from "src/internationalization";

function CaseTypeSinglePickerFormField<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>(props: PickerFormFieldPropsType<CaseType, TFieldValues, TName>) {
  const { data, loading, error } = useGetCaseTypesSchemasQuery();
  const t = useT();

  return (
    <SinglePickerFormField<CaseType, TFieldValues, TName>
      items={data}
      name={props.name}
      loading={loading}
      error={error}
      itemToString={(item) => item?.name ?? ""}
      invalidText={props.invalidText ?? t("component.picker.caseType.invalid")}
      titleText={props.titleText}
      helperText={props.helperText}
    />
  );
}

export default CaseTypeSinglePickerFormField;
